<app-categories-table categoryType="Fiber" [levels]="2" />
